<div class="email-detail" *ngIf="email">
  <header class="ed-head">
    <h2>{{ email.subject || '(bez předmětu)' }}</h2>
    <div class="ed-meta">
      <span><i class="pi pi-user"></i> {{ email.fromAddress || '—' }}</span>
      <span><i class="pi pi-calendar"></i> {{ email.date | date:'dd.MM.yyyy HH:mm' }}</span>
      <span class="ed-status">{{ statusLabels[email.analysisStatus] }}</span>
    </div>
  </header>

  <section class="ed-section">
    <h3>Obsah</h3>
    <pre class="ed-body">{{ email.body || '(prázdné tělo)' }}</pre>
  </section>

  <section class="ed-section" *ngIf="email.attachments.length">
    <h3>Přílohy</h3>
    <ul class="ed-attachments">
      <li *ngFor="let a of email.attachments">
        <i class="pi pi-file"></i>
        <a [href]="a.url" target="_blank" rel="noopener">{{ a.fileName }}</a>
      </li>
    </ul>
  </section>

  <section class="ed-section">
    <h3>Navázané přestupy</h3>
    <div class="ed-empty" *ngIf="email.linkedTransfers.length === 0">Žádný navázaný přestup.</div>
    <ul class="ed-transfers" *ngIf="email.linkedTransfers.length">
      <li *ngFor="let t of email.linkedTransfers" class="ed-transfer">
        <a [routerLink]="['/secured/transfers/detail', t.transferId]" class="ed-transfer-main">
          <span class="ed-player">{{ t.playerName }}</span>
          <span class="ed-clubs">{{ t.fromClubName }} → {{ t.toClubName }}</span>
          <span class="ed-tstatus">{{ transferStatusLabels[t.status] }}</span>
        </a>
        <button pButton type="button" label="Odpojit" icon="pi pi-times"
                class="p-button-text p-button-danger p-button-sm" (click)="unlink(t.transferId)"></button>
      </li>
    </ul>

    <div class="ed-link-row">
      <app-transfer-select [(ngModel)]="linkTransferId" placeholder="Napojit na přestup…"></app-transfer-select>
      <button pButton type="button" label="Napojit" icon="pi pi-link"
              class="p-button-outlined p-button-sm" [disabled]="!linkTransferId" (click)="linkToTransfer()"></button>
    </div>
  </section>
</div>
